import Vue from "vue";
import Vuex from "vuex";
Vue.use(Vuex);

const debug = process.env.NODE_ENV !== "production";

export default new Vuex.Store({
  state: {
    registerStatus: false, //注册状态
    pageLoading: true, // 页面加载中组件的状态控制；
    // 判断订单的类型 0 为线上下单，跳转到成功页面后点击确定按钮需要跳到订单的处理中状态；
    // 1 为扫码核销的订单,跳转到已完成的订单；
    // 2 为线下购买服务，跳转到卡券；
    globalOrderType: 0,
    storeInfo: [], //洗车门店信息
    coupon: {}
  },
  strict: debug,
  mutations: {
    setPageLoading(state, val) {
      state.pageLoading = val;
    },
    setGlobalOrderType(state, val) {
      state.globalOrderType = val;
    },
    setRegisterStatus(state, val) {
      state.registerStatus = val;
    },
    setStoreInfo(state, val) {
      state.storeInfo = val;
    },
    setCoupon(state, val) {
      state.coupon = val;
    }
  }
});
